<template>
  <span>{{ params.contenido }}</span>
</template>

<script>
export default {
  name: 'CabeceraAgGridPersonalizada',
};
</script>